import { TftfSelect } from 'assets/theme/StyledComponents';
import _ from 'lodash'
import React from 'react';
import Select, { ValueType } from 'react-select';
import { styled } from '../../assets/theme';

import { Modal } from '../Modal';

export interface IAddWatchOptions {
	type: string,
	wIndex: string,
	wIndexLabel: string,
	width: number,
	h: number,
	time: string
	unit: string,
}

interface ITimeOptions {
	value: '1' | '5' | '60' | '1D',
	label: string
}

const timeOptions: ITimeOptions[] = [
	{ value: '1', label: '1Min' },
	{ value: '5', label: '5Min' },
	{ value: '60', label: '60Min' },
	{ value: '1D', label: '1Day' },
];

interface IIndexOptions {
	value: string,
	label: string
}

const indexOptions: IIndexOptions[] = [
	{ value: 'VPMES', label: 'ES' },
	{ value: 'VPMNQ', label: 'NQ' },
	{ value: 'VPMSPX', label: 'SPX' },
	{ value: 'VPMNDX', label: 'NDX' },
	{ value: 'ROTATION', label: 'Rotation' },
];

interface IAddWatchProps {
	showModal: boolean,
	closeHandler: () => void,
	addHandler: (option: IAddWatchOptions) => void,
}

interface IAddWatchState {
	disable: boolean,
	selectedIndex: IIndexOptions | null,
	selectedTime: ITimeOptions | null
}

export class AddWatch extends React.Component<IAddWatchProps, IAddWatchState> {
	constructor(props: IAddWatchProps) {
		super(props);
		this.state = {
			disable: true,
			selectedIndex: null,
			selectedTime: null
		};
	}
	public onAdd = (e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		const { selectedTime, selectedIndex } = this.state;
		e.preventDefault();
		const h = 23;
		const width = 50;
		let options: IAddWatchOptions;
		if (!selectedIndex || !selectedTime) { return }
		if (selectedIndex.value === 'ROTATION') {
			options = {
        h: 33,
        time: '',
        type: 'watchRotation',
        unit: '',
        wIndex: selectedIndex.value,
        wIndexLabel: selectedIndex.label,
        width: 200,
      };
		} else {
			options = {
        h,
        time: selectedTime.value === '1D' ? '1' : selectedTime.label,
        type: 'watchIndex',
        unit: selectedTime.value === '1D' ? 'Day' : 'Min',
        wIndex: selectedIndex.value,
        wIndexLabel: selectedIndex.label,
        width,
      };
		}
		if (selectedIndex.value === 'ROTATION') {
			const watchboxGrid = localStorage.getItem('watchbox_grid')
			if (watchboxGrid) {
				const data = JSON.parse(watchboxGrid);
				let flag = false;
				if (data.watchBoxGrid && data.watchBoxGrid.length > 0) {
					_.each(data.watchBoxGrid, item => {
						if (item.type === 'watchRotation') {
							flag = true;
						}
					});
				}
				if (!flag) {
					this.props.addHandler(options);
				}
			} else {
				this.props.addHandler(options);
			}
		}
		this.props.closeHandler();
		this.setState({
      disable: true,
      selectedIndex: null,
      selectedTime: null
    });
	}

	public onCancel = () => {
		this.setState({
      disable: true,
      selectedIndex: null,
      selectedTime: null
    });
		this.props.closeHandler();
	}

	public handleIndexChange = (option: ValueType<IIndexOptions, false>) => {
		if (!option) { return }
		if (Array.isArray(option)) { return }
		const selectedOption = option as IIndexOptions
		this.setState({
			disable: selectedOption.value === 'ROTATION' ? false : true,
			selectedIndex: selectedOption,
		});
	}

	public handleTimeChange = (option: ValueType<ITimeOptions, false>) => {
		if (!option) { return }
		if (Array.isArray(option)) { return }
		const selectedOption = option as ITimeOptions
		this.setState({
			disable: selectedOption === null,
			selectedTime: selectedOption,
		});
	}

	public optionRenderer = (option: ITimeOptions | IIndexOptions) => (
		<div className="addform-option">
			{option.label}
		</div>);

	public render() {
		const { showModal } = this.props;
		const { disable, selectedTime, selectedIndex } = this.state;

		return (
			<Modal
				shouldShow={showModal}
				title="Add a Watch"
			>
				<form className="addForm" onSubmit={this.onAdd}>
					<div>
						<label className="modalLabel">Choose a Index</label>
                        <TftfSelect>
						<Select<IIndexOptions>
							placeholder="Select index type"
							className="react-select"
                            classNamePrefix="react-select"
							name="form-field-name"
							value={selectedIndex}
							options={indexOptions}
							onChange={this.handleIndexChange}
						/>
                        </TftfSelect>
					</div>
					{(selectedIndex && selectedIndex.value !== 'ROTATION') &&
						<div className="typeHeadBlock">
							<label className="modalLabel">Choose a Time</label>
                            <TftfSelect>
							<Select
								placeholder="Select time type"
								className="react-select"
                                classNamePrefix="react-select"
								name="form-field-name"
								value={selectedTime}
								options={timeOptions}
								onChange={this.handleTimeChange}
							/>
                            </TftfSelect>
						</div>
					}
					{(selectedIndex && selectedIndex.value === 'VPMESC') &&
						<div className="typeHeadBlock">
							<label className="modalLabel">Choose a Time</label>
                            <TftfSelect>
							<Select
								placeholder="Select time type"
								className="react-select"
                                classNamePrefix="react-select"
								name="form-field-name"
								value={selectedTime}
								options={[
									{ value: '1', label: '1Min' },
									{ value: '5', label: '5Min' }]
								}
								onChange={this.handleTimeChange}
							/>
                            </TftfSelect>
						</div>
					}
				</form>
				<AddFormFooter>
					<button className="modalBtn cancel" onClick={this.onCancel}>Cancel</button>
					<button className="modalBtn add" onClick={this.onAdd} disabled={disable}>Add watch</button>
				</AddFormFooter>
			</Modal>
		);
	}
}

const AddFormFooter = styled.div`
	display: grid;
	grid-auto-flow: column;
	justify-content: right;
	grid-gap: 1em;
	margin-top: 2em;
`;
